import { render, staticRenderFns } from "./PopupSelectVersion.vue?vue&type=template&id=e00633fe&"
import script from "./PopupSelectVersion.vue?vue&type=script&lang=js&"
export * from "./PopupSelectVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports